import React from "react";
import { useMetaPixel } from "./lib/useMetaPixel";
import { Hero } from "./components/Hero";
import { StatsBar } from "./components/StatsBar";
import { Transformation } from "./components/Transformation";
import { PainPoints } from "./components/PainPoints";
import { WhatsInside } from "./components/WhatsInside";
import { Tomos } from "./components/Tomos";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { ForYou } from "./components/ForYou";
import { FinalCta } from "./components/FinalCta";
import { Faq } from "./components/Faq";
import { FloatingCta } from "./components/FloatingCta";
const HERO_CTA_ID = "hero-cta";
export function App() {
  useMetaPixel();
  return <div className="w-full bg-[#fbf5f0]" data-id="element-0" data-mp="28sl48zil1qg1">
      <Hero ctaAnchorId={HERO_CTA_ID} data-id="element-1" data-mp="23vktwcepa1j4" />
      <StatsBar data-id="element-2" data-mp="23ujho4ly78zt" />
      <Transformation data-id="element-3" data-mp="23v2td3l0915e" />
      <PainPoints data-id="element-4" data-mp="3ijxq4swlw4ky" />
      <WhatsInside data-id="element-5" data-mp="3ikh829m9asyz" />
      <Tomos data-id="element-6" data-mp="3iiwfgpji5k3r" />
      <Bonuses data-id="element-7" data-mp="3ijfx0558q6h9" />
      <Offer data-id="element-8" data-mp="3ijpef4c7z5bc" />
      <Guarantee data-id="element-9" data-mp="3ii4r9zs8ioni" />
      <Testimonials data-id="element-10" data-mp="3mlayb9n68jv1" />
      <ForYou data-id="element-11" data-mp="3mkrgdsxitvh0" />
      <FinalCta data-id="element-12" data-mp="3mk85gw6ag7ch" />
      <Faq data-id="element-13" data-mp="3mjq2zht18ww4" />
      <FloatingCta anchorId={HERO_CTA_ID} data-id="element-14" data-mp="3mjgczu7zmpqf" />
    </div>;
}